import { render, staticRenderFns } from "./ControlSlider.vue?vue&type=template&id=2196f561&scoped=true"
import script from "./ControlSlider.vue?vue&type=script&lang=js"
export * from "./ControlSlider.vue?vue&type=script&lang=js"
import style0 from "./ControlSlider.vue?vue&type=style&index=0&id=2196f561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196f561",
  null
  
)

export default component.exports